/**
 * @name ForgotIdView.js
 * @description 아이디 찾기 - 로그인 모달 내부 전용 뷰
 * - 이름 + 전화번호 입력 후 아이디 표시
 * - props로 네비게이션 처리 (페이지 이동 없음)
 */
import React, { useState } from 'react';
import { post } from '@utils/axios_api';

const ForgotIdView = ({ onGoLogin, onGoForgotPw }) => {
  const [form, setForm] = useState({ name: '', phoneNo: '' });
  const [result, setResult] = useState(null);
  const [errorMsg, setErrorMsg] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const sanitized = name === 'phoneNo' ? value.replace(/\D/g, '') : value;
    setForm((prev) => ({ ...prev, [name]: sanitized }));
    setResult(null);
    setErrorMsg('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phoneNo) {
      setErrorMsg('이름과 전화번호를 모두 입력해 주세요.');
      return;
    }
    if (!/^01[0-9]\d{7,8}$/.test(form.phoneNo)) {
      setErrorMsg('올바른 전화번호 형식이 아닙니다. (예: 01012345678)');
      return;
    }

    setIsLoading(true);
    try {
      const response = await post('/auth/forgot-id', form, {
        headers: { 'Content-Type': 'application/json' },
      });

      if (response.result.success) {
        setResult(response.result.userIds);
        setErrorMsg('');
      } else {
        setResult(null);
        setErrorMsg(response.result.message || '일치하는 계정이 없습니다.');
      }
    } catch (err) {
      console.error('아이디 찾기 오류:', err);
      setErrorMsg('서버 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-form" style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <div className="logo text-center mb-3">
        <img src="/img/logo.png" alt="회사 로고" style={{ width: '100px', height: 'auto' }} />
      </div>
      <h1 className="text-center fs-4 fw-bold mb-3">아이디 찾기</h1>
      <p style={{ color: '#666', marginBottom: '16px', fontSize: '0.9rem', textAlign: 'center' }}>
        가입 시 등록한 이름과 전화번호를 입력해 주세요.
      </p>

      {result && (
        <div style={{
          background: '#e8f4fd',
          border: '1px solid #2196F3',
          borderRadius: '6px',
          padding: '16px',
          marginBottom: '16px',
          textAlign: 'center'
        }}>
          <p style={{ margin: 0, color: '#555', fontSize: '0.9rem' }}>
            {result.length === 1 ? '회원님의 아이디는' : `일치하는 아이디 ${result.length}개`}
          </p>
          {result.map((id, index) => (
            <p key={index} style={{ margin: '8px 0 0', fontWeight: 'bold', fontSize: '1.3rem', color: '#1976D2' }}>
              {id}
            </p>
          ))}
          <p style={{ margin: '8px 0 0', color: '#888', fontSize: '0.8rem' }}>
            아이디가 다를 경우 관리자에게 문의해 주세요.
          </p>
        </div>
      )}

      {errorMsg && (
        <p style={{ color: 'red', fontSize: '0.85rem', marginBottom: '12px' }}>{errorMsg}</p>
      )}

      {!result && (
        <form onSubmit={handleSubmit}>
          <div className="login_input_wrap">
            <input
              type="text"
              name="name"
              placeholder="이름을 입력해 주세요."
              value={form.name}
              onChange={handleChange}
              maxLength="20"
            />
            <input
              type="text"
              name="phoneNo"
              placeholder="전화번호를 입력해 주세요. (예: 01012345678)"
              value={form.phoneNo}
              onChange={handleChange}
              maxLength="11"
            />
            <p style={{ fontSize: '11px', color: '#888', margin: '3px 0 0' }}>- 없이 숫자만 입력하세요.</p>
          </div>
          <button
            type="submit"
            className="login-button"
            disabled={isLoading}
            style={{ marginTop: '16px' }}
          >
            {isLoading ? '조회 중...' : '아이디 찾기'}
          </button>
        </form>
      )}

      <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginTop: 'auto', paddingTop: '12px', fontSize: '0.9rem' }}>
        <button type="button" onClick={onGoLogin} style={{ background: 'none', border: 'none', color: '#555', cursor: 'pointer' }}>
          로그인
        </button>
        <span style={{ color: '#ddd' }}>|</span>
        <button type="button" onClick={onGoForgotPw} style={{ background: 'none', border: 'none', color: '#555', cursor: 'pointer' }}>
          비밀번호 찾기
        </button>
      </div>
    </div>
  );
};

export default ForgotIdView;
